import { render, staticRenderFns } from "./HRDashboard.vue?vue&type=template&id=5bb50f60&scoped=true&"
import script from "./HRDashboard.vue?vue&type=script&lang=js&"
export * from "./HRDashboard.vue?vue&type=script&lang=js&"
import style0 from "./HRDashboard.vue?vue&type=style&index=0&id=5bb50f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb50f60",
  null
  
)

export default component.exports